import { Checkbox } from "antd";
import React, { useRef, useState } from "react";
import { PiUserCircleCheckLight } from "react-icons/pi";
import logo from "../../../../assets/images/logo.png";
import {
  InputField,
  Modal,
  SubmitButton,
  TextComponent,
} from "../../../../components";
import styles from "./AddVehicalInformation.module.css";
import { useNavigate } from "react-router-dom";

const AddVehicalInformation = () => {
  const [success, setSuccess] = useState(false);
  const [successfulModal, setSuccessfulModal] = useState(false);
  const navigate = useNavigate();
  const imgRef = useRef();

  const onChange = (e) => {
    console.log(`checked = ${e.target.checked}`);
  };
  return (
    <div className={styles.mainCont}>
      <div className={styles.leftCont}>
        <img src={logo} className={styles.logoImg} />
      </div>
      <div className={styles.rightCont}>
        <div className={styles.subRightCont}>
          <TextComponent
            text={"Setup Vehicle Information"}
            className={styles.heading}
          />
          <TextComponent
            text={"Please provide detailed information about your vehicle."}
            // className={styles.heading}
          />
          <div className={styles.formDivideDiv}>
            <div className={styles.formDivideInput}>
              <img
                className={styles.slectImg}
                onClick={() => imgRef.current.click()}
                src={require("../../../../assets/images/uploadPicture.png")}
                alt=""
              />
              <input
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                ref={imgRef}
              />
            </div>
            <div className={styles.formDivideInput}>
              <InputField
                label={"Name"}
                // placeholder={"Write here"}
                // value={name}
                // onChange={(e) => setName(e.target.value)}
              />
              <InputField
                label={"Make"}
                // placeholder={"Write here"}
                // value={name}
                // onChange={(e) => setName(e.target.value)}
              />
            </div>
          </div>
          <InputField
            label={"Model"}
            // placeholder={"Write here"}
            // value={name}
            // onChange={(e) => setName(e.target.value)}
          />
          <div className={styles.formDivideDiv}>
            <InputField
              label={"VIN (Vehicle Identification Number)"}
              className={styles.formDivideInput}
              // placeholder={"Write here"}
              // value={name}
              // onChange={(e) => setName(e.target.value)}
            />
            <InputField
              label={"License Plate Number"}
              className={styles.formDivideInput}
              // placeholder={"Write here"}
              // value={name}
              // onChange={(e) => setName(e.target.value)}
            />
          </div>

          <Checkbox className={styles.check} onChange={onChange}>
            Enable geofencing and location tracking for added security
          </Checkbox>
          <div
            className={styles.btnDiv}
            onClick={() => setSuccessfulModal(true)}
          >
            <SubmitButton title={"Save Information"} />
          </div>
        </div>
      </div>
      <Modal
        open={successfulModal}
        onCancel={() => setSuccessfulModal(false)}
        icon={
          <PiUserCircleCheckLight
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Account created successfully"}
        width={"400px"}
        buttonTitle={"Continue"}
        onBtnPress={() => {
          setSuccessfulModal(false);
          navigate("/userDashboard", { replace: true });
        }}
        headingClass={styles.modalHeading}
      ></Modal>
    </div>
  );
};

export default AddVehicalInformation;
